import {autoserialize, inheritSerialization} from 'cerialize';
import {InterestedDriver} from './interested-driver';

@inheritSerialization(InterestedDriver)
export class InterestedTransitProgramDriver extends InterestedDriver {

  @autoserialize
  preferred: boolean;

  favorite: boolean;
}
